/**
 * These components are styled as buttons but used when we are redirecting the user to an
 * external page, e.g. when they forgot their password or need to set up an account
 */

const AnchorSecondary = ({ text, url, onClick, width, outlined = false }) => {
  const anchorOutline = outlined
    ? `inline-flex h-control-lg items-center justify-center rounded px-4 text-body-medium ${width} border border-border bg-surface text-ink transition-colors hover:bg-surface-muted active:bg-surface-pressed`
    : `inline-flex min-h-11 items-center justify-center rounded px-3 text-body-medium text-ink underline decoration-border underline-offset-4 transition-colors hover:decoration-ink`;
  return (
    <>
      <a href={url} className={anchorOutline} onClick={onClick} target="_blank">
        {text}
      </a>
    </>
  );
};

AnchorSecondary.defaultProps = {
  width: "w-auto",
};

export { AnchorSecondary };
